export default __webpack_public_path__ + "static/media/hero-phones.2e91ca11.png";